enum EApiDocumentCollection {
  documentCollection = '/externals/document-collections',
  documentCollectionDetail = '/externals/document-collections/:id',
}

export default EApiDocumentCollection;
